<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jmemLZ/tc-custom/9780795310959.jpg?1734320845296" alt="This image is the cover for the book Diana the Huntress, The Six Sisters Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diana the Huntress, The Six Sisters Series
      </h1>
      <p class="bookDescription body article font2">
        <b>The bad-mannered black sheep of the Armitage sisters finds love in spite of herself in this Regency romp from the <i>New York Times</i>–bestselling author.</b><br/>  <br/> Poor Diana! All she cares for is the hunt. But the statuesque brunette had been ordered by her father to throw off her male attire and learn the pretty ways of a marriageable miss. But not before the fair-haired Lord Dantry, encountering Diana in her disguise, invites the young “David Armitage” to spend a week with him in London. What Diana doesn’t foresee is that freedom has a price—and the price could be the man she loved.<br/>  <br/><b>Praise for M. C. Beaton and her novels</b><br/> “The best of the Regency writers.” —<i>Kirkus Reviews</i><br/>  <br/> “A delightful tale . . . romance fans are in for a treat.” —<i>Booklist</i><br/>  <br/> “Nicely atmospheric, most notable for its gentle humor and adventurous spirit.” —<i>Publishers Weekly</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        M. C. Beaton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20b839b4